import { SVGProps } from "react";

export const GoalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 10.3333V15" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.0835 15H10.9168" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.91667 1H1V4.5C1 6.11083 2.30584 7.41667 3.91667 7.41667V1Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0835 1H15.0002V4.5C15.0002 6.11083 13.6943 7.41667 12.0835 7.41667V1Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.9165 1V6.25C3.9165 8.50517 5.74467 10.3333 7.99984 10.3333C10.255 10.3333 12.0832 8.50517 12.0832 6.25V1H3.9165Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
